import React from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DetailsPaymentModal = ({ open, item, details, isLoading, onHide }) => (
  <Modal show={open} onHide={onHide} backdrop="static">
    {isLoading && <div className="modal-loader-small" />}
    <Modal.Header closeButton>
      <Modal.Title>{item.type === 'details' ? 'Details' : 'Details for superadmin'}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {details.superadmin_username ? (
        <FormGroup>
          <ControlLabel>Created by superadmin</ControlLabel>
          <FormControl type="text" name="superadmin_username" disabled defaultValue={details.superadmin_username} />
        </FormGroup>
      ) : null}

      <div className="break-all-words" dangerouslySetInnerHTML={{ __html: details.response }} />

      {details.ip ? (
        <FormGroup>
          <ControlLabel>IP</ControlLabel>
          <FormControl type="text" name="ip" disabled defaultValue={details.ip} />
        </FormGroup>
      ) : null}
      {details.initial_amount ? (
        <FormGroup>
          <ControlLabel>Initial amount</ControlLabel>
          <FormControl type="text" name="initial_amount" disabled defaultValue={details.initial_amount} />
        </FormGroup>
      ) : null}
    </Modal.Body>
    <Modal.Footer className="custom__modal-footer">
      <Button
        onClick={() => {
          onHide();
        }}
      >
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
);

DetailsPaymentModal.propTypes = {
  open: PropTypes.bool,
  item: PropTypes.object,
  details: PropTypes.object,
  isLoading: PropTypes.bool,
  onHide: PropTypes.func,
};

export default DetailsPaymentModal;
